import React from 'react';

import { HoverCard, HoverCardContent, HoverCardTrigger } from 'components/ui/hover-card';
import { useRouteChangeHandler } from 'shared/hooks';

function AboutUsMenu({ title, subMenu }: { title: string; subMenu: { to: string; title: string; target?: string }[] }) {
  const { handleRouteChange } = useRouteChangeHandler();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, to: string) => {
    e.preventDefault();

    window.dataLayer?.push({
      event: 'click_menu',
      menu: title,
      section: 'LNB',
    });

    if (to) {
      handleRouteChange(to);
    }
  };

  // TODO: 해당 부분은 tab으로 되지 않는 접근성 문제가 있으므로, 추후 처리함
  return (
    <li tabIndex={0}>
      <HoverCard openDelay={0} closeDelay={50}>
        <HoverCardTrigger tabIndex={0} className="cursor-pointer text-b3">
          {title}
        </HoverCardTrigger>

        <HoverCardContent className="w-auto whitespace-nowrap rounded-[10px] border-none bg-white px-[12px] py-[10px] text-center text-[12px]">
          <ul className="flex flex-col gap-2.5 font-medium">
            {subMenu.map(({ to, title, target }) => (
              <li key={to}>
                {target === '_blank' ? (
                  <a
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary"
                    onClick={() =>
                      window.dataLayer?.push({
                        event: 'click_menu',
                        menu: title,
                        section: 'LNB',
                      })
                    }
                  >
                    {title}
                  </a>
                ) : (
                  <a href={to} onClick={(e) => handleClick(e, to)} className="cursor-pointer hover:text-primary">
                    {title}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </HoverCardContent>
      </HoverCard>
    </li>
  );
}

export default AboutUsMenu;
